// eslint-disable-next-line import/no-anonymous-default-export
export default (dateOfBirth) => {
  // Convert the date of birth string to a Date object
  const dob = new Date(dateOfBirth);
  // Get the current date
  const currentDate = new Date();

  // Calculate the difference in years
  let age = currentDate.getFullYear() - dob.getFullYear();

  // Check if the birthday has occurred this year
  if (
    currentDate.getMonth() < dob.getMonth() ||
    (currentDate.getMonth() === dob.getMonth() &&
      currentDate.getDate() < dob.getDate())
  ) {
    age--;
  }

  return age;
};
